import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { NotificationPreferencesGroupCustomersPage } from './notification-preferences-group-customers.page';
import { NotificationPreferencesGroupCustomersPageRoutingModule } from './notification-preferences-group-customers-routing.module';
import { NotificationPreferencesModule } from '../notification-preferences.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NotificationPreferencesGroupCustomersPageRoutingModule,
    NotificationPreferencesModule,
    SharedModule,
    ScrollingModule,
  ],
  declarations: [NotificationPreferencesGroupCustomersPage],
})
export class NotificationPreferencesGroupCustomersPageModule {}
